import React from "react";
import "./AboutPage.css";
import logo from "../../Assets/logo.png";

const AboutPage: React.FC = () => {
  return (
    <>
      <div className="aboutSection">
        <h2>About Ganga Super Market</h2>
        <img src={logo} alt="Ganga Super Market Logo" />
        <div className="aboutContent">
          <h3>Our Story</h3>
          <p>
            Established/ Founded in 2015 as PLANET ENTERPRISES and had been involved with FMCG. Especially Indian Devotional items. We started with manufacturing / Trading the 100% Natural and traditional materials. Founded in 2020, GANGA SUPERMARKET - Grocery Store (Offline & Online Store) and started the Ganga Supermarket second outlet at Namakkal (Offline Store) in 2022.
            Planet Enterprises had been involved with technical activities of all Electrical Equipment's and Technical Field Service of AC High Voltage Machines (Motors & Generators). In recent years, we had also successfully qualified for the ABB AB Machines, Sweden and had been involved with the Technical Field Service of AC High Voltage Motors & Generators
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
